import React, { useEffect, useRef, useState } from 'react'
import {
  getAvatarDashboardChart,
  getAvatarDashboardMetrics,
  getAvatarReportChart,
  getAvatarSelectionReportMetrics,
  removeEmptyAttributes,
  searchAvatarReport,
} from 'src/api/reports'
import usePage from 'src/hooks/usePage'
import AvatarReportSearch from './avatarReportSearch'
import {
  Button,
  Card,
  Col,
  Row,
  Select,
  Space,
  Table,
  TablePaginationConfig,
} from 'antd'
import { DndProvider } from 'react-dnd'
import { DownloadOutlined, EyeOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { SorterResult, TableCurrentDataSource } from 'antd/lib/table/interface'
import AvatarCustomTimeseries from 'src/components/Charts/AvatarCustomTimeSeries'
import AvatarPieChart from 'src/components/Charts/AvatarPieChart'
import html2canvas from 'html2canvas'
const { Column } = Table
const AvatarReportPage: React.FC = () => {
  const {
    pageData,
    onQuery,
    appendSearchForm,
    submitSearchForm,
    fetchList,
    queryObj,
    searchForm,
  } = usePage({
    getData: searchAvatarReport,
    searchData: searchAvatarReport,
    searchType: 'POST',
  })
  const [loading, setLoading] = useState(true)
  const [metricsData, setMetricsData] = useState<AvatarMetricsDto>({
    totalAvatars: 0,
    totalAvatarSelections: 0,
    femalePercentage: 0,
    malePercentage: 0,
    totalAvatarCount: 0,
  totalCustomCharacterCount: 0,
  avatarPercentage: 0,
  characterPercentage: 0,
  })
  type SortItem = { field: string; order: 'asc' | 'desc' }
 const cardRefs = useRef([])
   const [avatarChart, setAvatarChart] = useState([])

  const handleTableChange = (
    pagination: TablePaginationConfig,
    _filters: Record<string, (string | number | boolean)[] | null>,
    sorter: SorterResult<any> | SorterResult<any>[],
    extra: TableCurrentDataSource<any>
  ) => {
    const current = pagination.current ?? 1
    const pageSize =
      pagination.pageSize ?? (parseInt(pageData.query.pageSize) || 10)

    const sorterArr = Array.isArray(sorter) ? sorter : [sorter]
    const sorts: SortItem[] = sorterArr
      .filter((s) => s && s.field && s.order)
      .map((s) => ({
        field: String(s.field),
        order: s.order === 'ascend' ? 'asc' : 'desc',
      }))

    if (extra.action === 'paginate') {
      appendSearchForm({ buttonAction: '' })
      onQuery({
        page: String(current - 1),
        pageSize: String(pageSize),
      })
      return
    }

    if (extra.action === 'sort') {
      onQuery({
        page: String(current - 1),
        pageSize: String(pageSize),
        sorts: JSON.stringify(sorts),
      })
      return
    }

    if (extra.action === 'filter') {
      onQuery({
        page: String(current - 1),
        pageSize: String(pageSize),
        sorts: JSON.stringify(sorts),
      })
    }
  }
  const handlePdfClick = () => {
    appendSearchForm({ buttonAction: 'Generate Pdf' })
    submitSearchForm()
  }

  const handleCsvClick = () => {
    appendSearchForm({ buttonAction: 'Generate Csv' })
    submitSearchForm()
  }
  const avatarMetricsPayload = {
    ...searchForm.current,
  }
  useEffect(() => {
    const fetchMetricsData = async () => {
      try {
        const data = await getAvatarSelectionReportMetrics(
          removeEmptyAttributes(avatarMetricsPayload)
        )
        if (data) {
          setMetricsData(data)
        }
      } catch (error) {
        console.error('Error fetching avatar metrics:', error)
      }
    }
    fetchMetricsData()
  }, [queryObj])

  const cardStyle: React.CSSProperties = {
    background: '#0b0b0b',
    borderRadius: 12,
  }
  const valueStyle = { color: '#6366f1' }
 const pieChartData = [
    {
      key: 'Characters',
      value: metricsData.avatarPercentage,
    },
    {
      key: 'Customized',
      value: metricsData.characterPercentage,
    },
  ];
  const handleDownload = async (index) => {
    if (!cardRefs.current[index]) return

    const canvas = await html2canvas(cardRefs.current[index], {
      scale: 2,
      ignoreElements: (element) => element.classList.contains('no-snapshot'),
    })
    const image = canvas.toDataURL('image/png')

    const link = document.createElement('a')
    link.href = image
    link.download = `card_snapshot_${index + 1}.png`
    link.click()
  }
  const metricsPayload = {
     ...searchForm.current,
                
              }
  const fetchAvatarDashboardMetricsData = async () => {
            try {
              
              const data = await getAvatarDashboardMetrics(metricsPayload)
              if (data) {
                setMetricsData(data)
              }
            } catch (error) {
              console.error('Error fetching avatar metrics:', error)
            }
          }
          const chartPayload = {
             ...searchForm.current,
                       
                      }
           const fetchAvatarDashboardChart = async () => {
                    try {
                      
                      const data = await getAvatarReportChart(chartPayload)
                      if (data) {
                        setAvatarChart(data)
                      }
                    } catch (error) {
                      console.error('Error fetching avatar metrics:', error)
                    }
                  }
                   useEffect(() => {
          
          fetchAvatarDashboardChart()
      }, [queryObj])
  return (
    <>
      <AvatarReportSearch
        appendSearchForm={appendSearchForm}
        submitSearchForm={submitSearchForm}
      />
     
           <div className="middle-content" style={{ marginTop: 20 }}>
        <Row gutter={[25, 25]}>
  {/* Column 1: Stacked Metric Cards */}
  <Col span={4}>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
      {/* Total Characters Card */}
      <Card
        style={{ borderRadius: '10px', padding: '1rem', color: 'white' }}
        bodyStyle={{ padding: 0 }}
      >
        <div style={{ marginBottom: '0.1rem', fontSize: '14px', color: '#ccc' }}>
          Total Characters
        </div>
        <div style={{ fontSize: '22px', color: '#3A63FF', fontWeight: 600 }}>
          {(metricsData?.totalAvatarCount ?? 0).toLocaleString()}
        </div>
      </Card>

      {/* Total Custom Avatars Card */}
      <Card
        style={{ borderRadius: '10px', padding: '1rem', color: 'white' }}
        bodyStyle={{ padding: 0 }}
      >
        <div style={{ marginBottom: '0.1rem', fontSize: '14px', color: '#ccc' }}>
          Total Custom Avatars
        </div>
        <div style={{ fontSize: '22px', color: '#3A63FF', fontWeight: 600 }}>
          {(metricsData?.totalCustomCharacterCount ?? 0).toLocaleString()}
        </div>
      </Card>
    </div>
  </Col>

  {/* Column 2: Timeseries Chart */}
  <Col span={12}>
    <Card
      ref={(el) => (cardRefs.current[2] = el)}
      title="Total Avatars"
      style={{ height: '100%' }}
      extra={
        <Button
          type="primary"
          className="no-snapshot"
          style={{ background: 'transparent', borderColor: 'transparent' }}
          shape="circle"
          icon={<DownloadOutlined />}
          onClick={() => handleDownload(2)}
        />
      }
    >
      <div style={{ height: 350, width: '100%' }}>
        <AvatarCustomTimeseries
          data={avatarChart}
          chartHeight={300}
        />
      </div>
    </Card>
  </Col>

  {/* Column 3: Pie Chart */}
  <Col span={8}>
    <Card
      ref={(el) => (cardRefs.current[3] = el)}
      title="Avatar Type"
      style={{ height: '100%' }}
      extra={
        <Button
          type="primary"
          className="no-snapshot"
          style={{ background: 'transparent', borderColor: 'transparent' }}
          shape="circle"
          icon={<DownloadOutlined />}
          onClick={() => handleDownload(3)}
        />
      }
    >
      <div style={{ height: 350, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <AvatarPieChart
          data={pieChartData}
          colorKey={'Characters'}
          pieColors={['#648858', '#4754a6']}
        />
      </div>
    </Card>
  </Col>
</Row>
      </div>
     

      <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
        <Col>
          <span style={{ fontSize: 24 }}>
            Search Results ({pageData.total})
          </span>
        </Col>
        <Col>
          <Select
            placeholder="Export"
            style={{ width: 160 }}
            onSelect={(value) => {
              if (value === 'pdf') {
                handlePdfClick()
              } else if (value === 'csv') {
                handleCsvClick()
              }
            }}
            allowClear
          >
            <Select.Option value="pdf">Export as PDF</Select.Option>
            <Select.Option value="csv">Export as CSV</Select.Option>
          </Select>
        </Col>
      </Row>
      <DndProvider backend={HTML5Backend}>
        <Table
          className="table-sorting"
          rowKey="eventId"
          dataSource={pageData.data}
          loading={pageData.loading}
          onChange={handleTableChange}
          pagination={{
            current: parseInt(pageData.query.page) + 1,
            total: pageData.total,
            pageSize: parseInt(pageData.query.pageSize) || 10,
            showSizeChanger: true,
            pageSizeOptions: ['10', '25', '50', '100'],
          }}
        >
          <Column
            dataIndex="avatarName"
            title="Avatar Name"
            sorter={{ multiple: 1 }}
          />
           <Column
            dataIndex="selectionDate"
            title="Date"
            sorter={{ multiple: 1 }}
          />
          
          <Column
            dataIndex="noOfSelection"
            sorter={{ multiple: 1 }}
            title="No. of Used"
            align="center"
          />

          <Column
            dataIndex="deviceType"
            sorter={{ multiple: 1 }}
            title="Device"
            align="center"
          />

          <Column
            dataIndex="gender"
            title="Gender"
            align="center"
            sorter={{ multiple: 1 }}
            filters={[
              {
                text: 'Male',
                value: 'MALE',
              },
              {
                text: 'Female',
                value: 'FEMALE',
              },
            ]}
            filterMode="tree"
            onFilter={(value: string, record: any) => record.gender === value}
          />

          <Column
            dataIndex="country"
            sorter={{ multiple: 2 }}
            title="Country"
            align="center"
          />

          <Column<{ userName: string }>
            title="Action"
            key="url"
            render={(_, record) => (
              <Space size="middle">
                <Link
                  to={`/users/detail/${record.userName}`}
                  className="link-btn"
                >
                  <EyeOutlined />
                </Link>
              </Space>
            )}
          />
        </Table>
      </DndProvider>
    </>
  )
}
AvatarReportPage.displayName = 'AvatarReportPage'
export default AvatarReportPage
